import { getLogger } from "@src/cloud-connect/dependency-injection-container/get-logger";
import { getMachineStructureNodeset } from "@src/cloud-connect/dependency-injection-container/get-machine-structure-nodeset";
import { OurNode } from "@src/cloud-connect/poc/our-node";

export class MachineCaretClickHandler {
  toggleExpanded(node: OurNode) {
    const logger = getLogger();
    const t0 = performance.now();
    logger.debug("t0 - start of action", t0);
    node.toggleNodeCollapse();

    const machineStructureNodeset = getMachineStructureNodeset();
    const singleRootNode = node.returnRootNodeFromOurNode();
    machineStructureNodeset.setRootNode(singleRootNode);
    const flatMap = singleRootNode.createMapFromOurNodeTree();
    machineStructureNodeset.setFlatMap(flatMap);

    // Notify observers of the change
    machineStructureNodeset.notifyObservers();

    const t1 = performance.now();
    logger.debug("t1 - end of action", t1);
    logger.debug(
      `Action to toggle expanded state of initial structure node in new structure took ${
        t1 - t0
      } milliseconds.`,
    );
  }
}
